export default __webpack_public_path__ + "assets/stocked-fridge/stocked-fridge-details-header.7ec1ef870946ee48a302f8ac03a56a8e.webp";